import { PostAPI } from 'Components/Helper/Helpers';

export const MultiActivePPI = async (request) => {
    return PostAPI(request, 'PPISetting/SelectMultiActivePPI');
};

export const Select = async (request) => {
    return PostAPI(request, 'PPISetting/Select');
};

export const SelectByID = async (request) => {
    return PostAPI(request, 'PPISetting/SelectByID');
};

export const Update = async (request) => {
    return PostAPI(request, 'PPISetting/Update');
};
